import { render, staticRenderFns } from "./RevalidacaoDePalavra.vue?vue&type=template&id=4925642d&scoped=true"
import script from "./RevalidacaoDePalavra.vue?vue&type=script&setup=true&lang=ts"
export * from "./RevalidacaoDePalavra.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RevalidacaoDePalavra.vue?vue&type=style&index=0&id=4925642d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4925642d",
  null
  
)

export default component.exports